import { defineStore } from 'pinia'
import axios from 'axios'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    initialized: false,
  }),

  actions: {
    async init() {
      if (this.initialized) return
      try {
        const res = await axios.get('/auth/me')
        this.user = res.data
      } catch {
        this.user = null
      }
      this.initialized = true
    },

    logout() {
      this.user = null
      this.initialized = false
      window.location.href = '/auth/logout'
    },

    clearSession() {
      this.user = null
      this.initialized = false
    }
  }
})
